import React from "react";

import clsx from "clsx";

import { Column, Row } from "@/components/containers";

export interface ChargePointResultProps {
  currentPoints: number;
  className?: string;
}

export function ChargePointResult({
  currentPoints,
  className,
}: ChargePointResultProps): React.ReactNode {
  return (
    <Column
      className={clsx(
        "w-full rounded-[10px] bg-[#fff] border-[#c8c8c8] border-solid border-[1px] box-border p-[20px] gap-2.5 leading-[normal] tracking-[normal] text-left text-[16px] text-[#5a5a5a]",
        className
      )}
      align="center"
    >
      <Row align="center" gap={10}>
        <div className="relative leading-[24px]">現在の保有ポイント</div>
      </Row>
      <Row align="end" gap={3} className="text-[32px]">
        <b className="relative leading-[44px]">{currentPoints.toLocaleString()}</b>
        <b className="relative text-[20px] leading-[28px] pl-[2px]">pt</b>
      </Row>
    </Column>
  );
}
